import { FuelToast } from '@frete.com/fuel-react'
import styled, { css } from 'styled-components'
import { ToastProps } from './interfaces'

export const Toast = styled(FuelToast)<ToastProps>`
  position: fixed;
  left: 130px;
  width: fit-content;

  ${({ $mobile, $isOpen, theme }) =>
    $mobile &&
    css`
      left: unset;
      right: 0px;
      padding: 0 ${$isOpen ? theme.spacing.km6 : '0'};
      top: ${theme.spacing.km6};
    `};
`
